import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class CheckoutService extends BaseService {

    static url = "orders";
    static apis = {
        delivery_cost: { path: this.url + "/delivery_cost", method: "post" },
        seller_shipping_logistics: { path: this.url + "/seller-shipping-logistics", method: "post" },
        get_seller_shipping_logistics: function (order_kit_id) {
            return  "orders/seller-shipping-logistics/" + order_kit_id  
        },
        payment: { path: this.url + "/payment", method: "post" },
        validateCoupon: { path: this.url + "/validateCoupon", method: "post" },
        getKits: function (id) {
            return "orders" + "/" + id + "/" + "kits"
        },
        priceBreakDown: function() {
            return "orders/priceBreakDown"
        },
        createDeposit: {path: this.url + "/deposit", method: "post"},
        createWireTransaction : {path: this.url + "/wirePayment", method: "post"},
        createCardTransaction : {path: this.url + "/cardPayment", method: "post"},
        createPayPalTransaction : {path: this.url + "/paypalPayment", method: "post"},

        editOrder : {path: this.url + "/editOrder", method: "put"},
        cancelOrders:{path:this.url, method:'delete'},
        getOrderById : {path: this.url + "/getOrderById", method: "get"},
        getLatest : {path: this.url + "/getLatest", method: "get"},

        payment_methods:{path: this.url + "/payment_methods", method: "get"},
        getWireTransferInfo:{path: this.url+"/get-wire-transfer-info", method: "get"},
        order_statuses:{path: "order_statuses/enabled", method: "get"},
        save_seller_info:{path: this.url+"/save_seller_info", method: "post"},
        get_seller_info:{path: this.url+"/get_seller_info", method: "get"},
        get_billing_company_by_country_name:{path: this.url+"/billing-company", method: "get"},
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("orders");
    }

    get_billing_company_by_country_name(country_name)
    {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.get_billing_company_by_country_name.path+'/'+country_name,
                method: CheckoutService.apis.get_billing_company_by_country_name.method,
                authorization: false,
               
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });   
    }

    save_seller_info(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.save_seller_info.path,
                method: CheckoutService.apis.save_seller_info.method,
                authorization: true,
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    update_seller_shipping_logistics(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.seller_shipping_logistics.path,
                method: CheckoutService.apis.seller_shipping_logistics.method,
                authorization: true,
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    get_seller_info(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.get_seller_info.path,
                method: CheckoutService.apis.get_seller_info.method,
                authorization: true,
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    

    payment(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.payment.path,
                method: CheckoutService.apis.payment.method,
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }


    orderStatuses() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.order_statuses.path,
                method: CheckoutService.apis.order_statuses.method,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    editOrder(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.editOrder.path,
                method: CheckoutService.apis.editOrder.method,
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    cancelOrders(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.cancelOrders.path,
                method: CheckoutService.apis.cancelOrders.method,
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    getLatest(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.getLatest.path,
                method: CheckoutService.apis.getLatest.method,
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }
    payment_methods(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.payment_methods.path,
                method: CheckoutService.apis.payment_methods.method,
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    payment_method(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.payment_methods.path + '/' + id,
                method: CheckoutService.apis.payment_methods.method,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    getWireTransferInfo($order_id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.getWireTransferInfo.path+'/'+$order_id,
                method: CheckoutService.apis.getWireTransferInfo.method,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    getOrderById(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CheckoutService.apis.getOrderById.path+'?id='+data,
                method: CheckoutService.apis.getOrderById.method,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    createDeposit(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CheckoutService.apis.createDeposit.path, method: CheckoutService.apis.createDeposit.method, authorization:true, data: data, showLoader: false })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    createWireTransaction(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CheckoutService.apis.createWireTransaction.path, method: CheckoutService.apis.createWireTransaction.method, authorization:true, data: data, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    createCardTransaction(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CheckoutService.apis.createCardTransaction.path, method: CheckoutService.apis.createCardTransaction.method, authorization:true, data: data, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    createPayPalTransaction(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CheckoutService.apis.createPayPalTransaction.path, method: CheckoutService.apis.createPayPalTransaction.method, authorization:true, data: data, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getDeliveryCost(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CheckoutService.apis.delivery_cost.path, method: CheckoutService.apis.delivery_cost.method, authorization:false, data: data, showLoader: false })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getPriceBreakdown(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CheckoutService.apis.priceBreakDown(), method:"GET", authorization:true, params: data, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    validateCoupon(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CheckoutService.apis.validateCoupon.path, method: CheckoutService.apis.validateCoupon.method, data: data, authorization:false, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getKits(id, data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CheckoutService.apis.getKits(id), params: data, method: "get", authorization: true, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    get_seller_shipping_logistics(order_kit_id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CheckoutService.apis.get_seller_shipping_logistics(order_kit_id),  method: "get", authorization: true, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}

export default CheckoutService;